<template>
  <div class="download-page clearfix">
    <div class="platform-info"></div>
    <div class="content">
      <div class="title-wrap">
        <p class="title">下载魔果云课客户端</p>
        <p class="tips">同时支持 iOS，Android，iPhone，mac，Windows版本</p>
      </div>
      <div class="download-area">
        <ul class="download-list">
          <li
            v-for="item in downloadList"
            :key="item.id"
            class="item-wrap"
            @click="download(item.url, item.type)"
            :class="{ 'item-qrcode': ['android', 'ios'].includes(item.type) }"
          >
            <div class="img-wrap">
              <img
                class="type-img"
                :src="
                  require('../../assets/images/download/' +
                    item.type +
                    '-icon.png')
                "
              />
              <img
                v-if="['mac', 'windows'].includes(item.type)"
                class="download-img"
                :src="downloadImg"
                alt=""
              />
              <div
                v-else
                :id="'qrcodeCont' + item.id"
                class="download-img"
              ></div>
              <!-- <div
                  v-if="['android', 'ios'].includes(item.type)"
                  class="qrcode"
                ></div> -->
            </div>
            <p class="text-wrap">
              <span class="type-text">{{ item.typeText }}</span>
              <span class="download-text">{{ item.hoverText }}</span>
            </p>
          </li>
        </ul>
      </div>
      <div class="hardware-config">
        <p class="module-title">硬件配置需求</p>
        <!-- pc -->
        <ul class="hardware-item pc-config">
          <li
            class="config-item"
            v-for="(item, index) in pcConfig"
            :key="item.type"
          >
            <p class="type-title">{{ item.type }}</p>
            <ul class="detail">
              <li class="type-row" style="background: transparent">
                <p class="name" v-if="index === 0"></p>
                <p class="windows">Windows</p>
                <p class="mac">Mac</p>
              </li>
              <li v-for="require in item.requirement" :key="require.name">
                <p class="name" v-if="index === 0">{{ require.name }}</p>
                <p class="windows">{{ require.windows }}</p>
                <p class="mac">{{ require.mac }}</p>
              </li>
            </ul>
          </li>
        </ul>
        <!-- app -->
        <ul class="hardware-item app-config">
          <li
            class="config-item"
            v-for="(item, index) in appConfig"
            :key="item.type"
          >
            <p class="type-title">{{ item.type }}</p>
            <ul class="detail">
              <li v-for="require in item.requirement" :key="require.name">
                <p class="name" v-if="index === 0">{{ require.name }}</p>
                <p class="info">{{ require.info }}</p>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog
      :visible.sync="selectMacTypeVisible"
      width="933px"
      class="mac-type-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="content-wrap">
        <div class="title">请选择适合您的 Mac 端版本</div>
        <div class="download-btn">
          <button class="intel-btn" @click.stop="downloadMac('intel')">
            下载 Intel 芯片版
          </button>
          <el-button type="primary" @click.stop="downloadMac('apple')">
            下载 Apple 芯片版
          </el-button>
        </div>
        <hr />
        <div class="tips-content">
          <p class="tips-title"><i></i> 如何确认芯片类型？</p>
          <ul class="tips-list">
            <li class="tips-item">
              <img
                src="../../assets/images/download/mac-download1.png"
                alt=""
              />
              <p class="text">
                1、在左上角，打开<span>Apple菜单</span>选择“
                <span>关于本机</span>”
              </p>
            </li>
            <li class="tips-item">
              <img
                src="../../assets/images/download/mac-download2.png"
                alt=""
              />
              <p class="text">
                2、在“<span>处理器</span>”或“<span>芯片</span>”中查看是“
                <span>Intel</span>”还是“<span>Apple</span>”
              </p>
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDownloadConfig,
  getAndroidAppVersion,
  getIosAppVersion,
} from "@saas/server-api/src/index";
import QRCode from "qrcodejs2";
export default {
  data: function () {
    return {
      downloadImg: require("../../assets/images/download/download-icon.png"),
      pcConfig: [
        {
          type: "电脑端-讲师/助教",
          requirement: [
            {
              name: "处理器",
              windows: "i5处理器，主频2.0GHz以上",
              mac: "Intel/M 系列处理器",
            },
            {
              name: "操作系统",
              windows: "Windows7 及更高版本",
              mac: "MacOS X10.10 及更高版本",
            },
            {
              name: "内存",
              windows: "4GB 及以上",
              mac: "4GB 及以上",
            },
            {
              name: "显示",
              windows: "不低于1280x720分辦率",
              mac: "不低于1280x720分辦率",
            },
            {
              name: "网络",
              windows: "上下行不低于 4Mbps",
              mac: "上下行不低于 4Mbps",
            },
          ],
        },
        {
          type: "电脑端-学员",
          requirement: [
            {
              name: "处理器",
              windows: "i5 及以上",
              mac: "Intel/M 系列处理器",
            },
            {
              name: "操作系统",
              windows: "Windows7 及更高版本",
              mac: "MacOS X10.10 及更高版本",
            },
            {
              name: "内存",
              windows: "2GB 及以上",
              mac: "2GB 及以上",
            },
            {
              name: "显示",
              windows: "不低于1280x720分辦率",
              mac: "不低于1280x720分辦率",
            },
            {
              name: "网络",
              windows: "上下行不低于 2Mbps",
              mac: "上下行不低于 2Mbps",
            },
          ],
        },
      ],
      appConfig: [
        {
          type: "Android 端 - 学员",
          requirement: [
            {
              name: "处理器",
              info: "骁龙 845、麒麟 980 同等级及以上芯片",
            },
            {
              name: "操作系统",
              info: "Android 8.0 及更高版本",
            },
            {
              name: "内存",
              info: "RAM 6GB 及以上，ROM 64GB 及以上",
            },
            {
              name: "网络",
              info: "上下行不低于 2Mbps",
            },
          ],
        },
        {
          type: "iOS 端（iPhone/iPad） - 学员",
          requirement: [
            {
              name: "处理器",
              info: "A12 及以上芯片/M 系列芯片",
            },
            {
              name: "操作系统",
              info: "iOS 12.0 及更高版本",
            },
            {
              name: "内存",
              info: "RAM 3GB 及以上，ROM 64GB 及以上",
            },
            {
              name: "网络",
              info: "上下行不低于 2Mbps",
            },
          ],
        },
      ],
      downloadList: [
        {
          id: 1,
          type: "windows",
          typeText: "Windows电脑端",
          hoverText: "点击下载",
          url: process.env.VUE_APP_WIN_URL,
        },
        {
          id: 2,
          type: "mac",
          typeText: "Mac电脑端",
          hoverText: "点击下载",
          url: process.env.VUE_APP_MAC_API,
          intel: process.env.VUE_APP_MAC_API_INTEL,
        },
        {
          id: 3,
          type: "ios",
          typeText: "iPhone & iPad",
          hoverText: "扫码下载",
          url: process.env.VUE_APP_IOS_API,
        },
        {
          id: 0,
          type: "android",
          typeText: "Android",
          hoverText: "扫码下载",
          url: process.env.VUE_APP_ANDROID_API,
        },
      ],
      selectMacTypeVisible: false,
    };
  },
  created() {},
  mounted() {
    this.apiGetDownloadUrl();
  },
  methods: {
    inintData() {
      Promise.all([getAndroidAppVersion(), getIosAppVersion()]).then((res) => {
        let [androidRes, iosRes] = res;
        if (androidRes.code === 1 && androidRes?.data?.url) {
          let index = this.downloadList.findIndex(
            (item) => item.type === "android"
          );
          if (index !== -1) {
            this.downloadList[index].url = androidRes.data.url;
          }
        }
        if (iosRes.code === 1 && iosRes?.data?.url) {
          let index = this.downloadList.findIndex(
            (item) => item.type === "ios"
          );
          this.downloadList[index].url = iosRes.data.url;
        }
        this.createQrcode();
      });
    },
    apiGetDownloadUrl() {
      getDownloadConfig()
        .then((data) => {
          if (data?.data?.length) {
            this.downloadList.forEach((item) => {
              let downItem = data.data.filter((ele) => ele.id === item.id);
              if (downItem.length) {
                item.url = downItem[0].url;
              }
              if (item.id === 2) {
                item.intel = downItem[0].intel;
              }
            });
          }
          this.inintData();
        })
        .catch((err) => {
          console.log(err);
          this.inintData();
        });
    },
    createQrcode() {
      let qrcodeOptions = {
        width: 170,
        height: 170,
        colorDark: "#ffffff",
        colorLight: "transparent",
        correctLevel: QRCode.CorrectLevel.H,
      };
      new QRCode(document.getElementById("qrcodeCont0"), {
        text: this.downloadList[
          this.downloadList.findIndex((item) => item.id === 0)
        ].url,
        ...qrcodeOptions,
      });
      new QRCode(document.getElementById("qrcodeCont3"), {
        text: this.downloadList[
          this.downloadList.findIndex((item) => item.id === 3)
        ].url,
        ...qrcodeOptions,
      });
    },
    download(url, type) {
      if (type === "mac") {
        this.selectMacTypeVisible = true;
        return;
      } else if (["ios", "android"].includes(type)) {
        return;
      }
      if (!url) return;
      window.open(url);
    },
    downloadMac(type) {
      let macItem = this.downloadList.filter((item) => {
        return item.id === 2;
      });
      if (!macItem?.length) return;
      if (type === "intel") {
        window.open(macItem[0].intel);
      } else {
        window.open(macItem[0].url);
      }
    },
    // scrollDownload() {
    //   if (this.$refs.downloadArea) {
    //     this.$refs.downloadArea.scrollIntoView({
    //       behavior: "smooth",
    //       block: "start",
    //     });
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.download-page {
  min-height: calc(100vh - 80px);
  min-width: 1200px;
  background: #fff;
  position: relative;
  .platform-info {
    position: absolute;
    width: 100%;
    background: linear-gradient(180deg, #e7f3eb 0%, #ffffff 100%, #ffffff 100%);
    height: 1026px;
  }
  .content {
    position: relative;
    background: transparent;
    min-height: auto;
    padding-top: 106px;
    &::after {
      position: absolute;
      content: "";
      top: 7px;
      right: 11px;
      width: 425px;
      height: 347px;
      z-index: 2;
      background: url("../../assets/images/download/download-bg.png");
      background-size: 100% 100%;
    }
    .title-wrap {
      padding-left: 30px;
      padding-bottom: 137px;
    }
    .title {
      font-weight: 600;
      font-size: 50px;
      color: #0d1400;
      line-height: 70px;
      margin-bottom: 16px;
    }
    .tips {
      font-weight: 400;
      font-size: 16px;
      color: #0d1400;
      line-height: 26px;
    }
  }
  .download-area {
    .download-list {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: space-around;
      .item-wrap {
        position: relative;
        cursor: pointer;
        .text-wrap {
          font-size: 18px;
          color: #333333;
          line-height: 25px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          .type-text {
            opacity: 1;
            transition: all 0.2s;
          }
          .download-text {
            transition: all 0.2s;
            opacity: 0;
            position: absolute;
            top: 265px;
          }
        }
        .img-wrap {
          overflow: hidden;
          position: relative;
          width: 210px;
          height: 210px;
          background: #ffffff;
          box-shadow: 0px 10px 20px 0px rgba(102, 116, 107, 0.1);
          border-radius: 24px;
          margin-bottom: 30px;
          img {
            width: 90px;
            height: 90px;
          }
          .download-img {
            position: absolute;
            transition: all 0.2s;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            opacity: 0;
          }
          .type-img {
            transition: all 0.2s;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
          }
          .qrcode {
            position: absolute;
            right: 0;
            top: 0;
            width: 80px;
            height: 90px;
            background-image: url("../../assets/images/download/qrcode-icon.png");
            background-position: 50%;
            background-size: cover;
            transition: all 0.3s;
          }
        }
      }

      .item-wrap:hover {
        .type-img {
          opacity: 0;
          transform: translate(-50%, -50%) scale(0);
        }
        .download-img {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }
        .type-text {
          opacity: 0;
          transform: translateY(-25px);
        }
        .download-text {
          opacity: 1;
          transform: translateY(-25px);
        }
        .qrcode {
          top: -40px;
          right: -40px;
        }
      }
      .item-wrap.item-qrcode:hover {
        .img-wrap {
          background: $saas-theme-color;
        }
        .download-img {
          width: 170px;
          height: 170px;
        }
      }
    }
  }
  .hardware-config {
    // background: linear-gradient(
    //   180deg,
    //   rgba(251, 251, 251, 0.7) 0%,
    //   #ffffff 15%,
    //   #ffffff 82%,
    //   rgba(245, 246, 246, 0.7) 100%
    // );
  }
  .hardware-config {
    padding: 60px 0 0 0;
    .hardware-item {
      margin-top: 50px;
      display: flex;
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      .config-item {
        flex: 1;
        &:first-child {
          width: 740px;
          .type-title {
            margin-left: 200px;
          }
          .detail > li:nth-child(2n) {
            border-radius: 4px 0 0 4px;
          }
        }
        .type-title {
          // text-align: center;
          width: 500px;
          font-weight: 600;
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin-bottom: 14px;
        }
        .detail > li {
          display: flex;
          height: 40px;
          line-height: 40px;
          white-space: nowrap;
          &:nth-child(2n) {
            background: #f7f8fa;
            border-radius: 6px;
          }
          .name {
            width: 200px;
            padding-left: 36px;
          }
          .windows {
            width: 224px;
            // text-align: right;
            margin-right: 38px;
          }
          .mac {
            width: 278px;
          }
        }
      }
    }
    .hardware-item.app-config {
      padding-bottom: 100px;
      .info {
        // text-align: center;
        width: 540px;
      }
      .detail > li:nth-child(2n-1) {
        background: #f7f8fa;
        border-radius: 6px;
      }
      .detail > li:nth-child(2n) {
        background: transparent;
      }
      .config-item:first-child {
        .detail > li:nth-child(2n-1) {
          border-radius: 4px 0 0 4px;
        }
      }
    }
  }

  // 公共
  .module-title {
    padding-top: 114px;
    text-align: center;
    margin-bottom: 60px;
    font-weight: 600;
    font-size: 40px;
    color: #0d1400;
    line-height: 56px;
  }
}

// 弹窗
.mac-type-dialog {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
  ::v-deep .el-dialog {
    border-radius: 8px;
  }
}
.content-wrap {
  margin: 0 auto;
  width: 721px;
  padding-top: 40px;
  .title {
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 33px;
    text-align: center;
    margin-bottom: 30px;
  }
  .download-btn {
    margin-bottom: 30px;
    text-align: center;
    .el-button {
      width: 339px;
      height: 54px;
    }
    .intel-btn {
      margin-right: 43px;
      width: 339px;
      height: 54px;
      background: rgba($color: $saas-theme-color, $alpha: 0.2);
      border-radius: 4px;
      border: 1px solid $saas-theme-color;
      font-weight: 500;
      font-size: 16px;
      color: $saas-theme-color;
      line-height: 22px;
    }
  }
  .tips-content {
    margin-top: 20px;
    padding-bottom: 77px;
    .tips-title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      margin-bottom: 20px;
      i {
        width: 4px;
        height: 16px;
        background: $saas-theme-color;
        border-radius: 3px;
        display: inline-block;
        margin-right: 12px;
      }
    }
    .tips-list {
      display: flex;
    }
    .tips-item {
      &:first-child {
        margin-right: 43px;
      }
      img {
        width: 339px;
        height: 198px;
        margin-bottom: 20px;
      }
      .text {
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        span {
          color: $saas-theme-color;
        }
      }
    }
  }
}
</style>
